import { AlertTriangle, Settings, ExternalLink } from 'lucide-react'

interface ConfigurationRequiredProps {
  title: string
  message: string
  details?: string[]
  onConfigureClick?: () => void
}

export function ConfigurationRequired({
  title,
  message,
  details,
  onConfigureClick,
}: ConfigurationRequiredProps) {
  return (
    <div className="bg-tf-feedback-warning-bg border border-tf-feedback-warning-border rounded-xl p-6">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-tf-feedback-warning-bg flex items-center justify-center">
          <AlertTriangle className="w-5 h-5 text-tf-feedback-warning-text" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-base font-semibold text-tf-feedback-warning-text mb-1">{title}</h3>
          <p className="text-sm text-tf-feedback-warning-text mb-3">{message}</p>

          {details && details.length > 0 && (
            <div className="bg-tf-bg-card/60 rounded-lg p-3 mb-4">
              <p className="text-xs font-medium text-tf-feedback-warning-text mb-2">Expected Campaign Naming Convention:</p>
              <code className="text-xs text-tf-feedback-warning-text bg-tf-feedback-warning-bg px-2 py-1 rounded block">
                {'{PRODUCT_CODE}_{PRODUCT_NAME}_{LAYER}_{COUNTRY}_{STRATEGY}_...'}
              </code>
              <p className="text-xs text-tf-feedback-warning-text mt-2">
                Example: <code className="bg-tf-feedback-warning-bg px-1 rounded">10035_SWEETHEART_PPT_US_ACQ_VOLUME_CBO</code>
              </p>
              <ul className="text-xs text-tf-feedback-warning-text mt-3 space-y-1">
                {details.map((detail, index) => (
                  <li key={index} className="flex items-start gap-1.5">
                    <span className="text-tf-feedback-warning-text mt-0.5">•</span>
                    <span>{detail}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          <div className="flex items-center gap-3">
            {onConfigureClick && (
              <button
                onClick={onConfigureClick}
                className="inline-flex items-center gap-2 px-4 py-2 bg-tf-feedback-warning-text text-white text-sm font-medium rounded-lg hover:opacity-90 transition-colors"
              >
                <Settings className="w-4 h-4" />
                Configure Naming Convention
              </button>
            )}
            <a
              href="#"
              className="inline-flex items-center gap-1 text-sm text-tf-feedback-warning-text hover:opacity-80"
            >
              Learn more
              <ExternalLink className="w-3.5 h-3.5" />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ConfigurationRequired
